import { z } from "zod";
import { OpaqueIdSchema } from "./schemas";

export const DOCUMENT_RETENTION_SECONDS = 30 * 24 * 60 * 60;
export const DocumentTrashSourceSchema = z.enum(["commercial", "library", "internal"]);
export const DocumentTrashRequestSchema = z.strictObject({
  expectedRevision: z.number().int().positive(),
});
export const DocumentTrashItemSchema = z.strictObject({
  id: OpaqueIdSchema,
  documentId: OpaqueIdSchema,
  source: DocumentTrashSourceSchema,
  title: z.string(),
  kind: z.string(),
  deletedAt: z.number().int(),
  purgeAfter: z.number().int(),
  deletedBy: z.string(),
  canRestore: z.boolean().default(false),
});
export const DocumentTrashListSchema = z.strictObject({
  documents: z.array(DocumentTrashItemSchema).max(50),
  nextCursor: OpaqueIdSchema.nullable(),
});
export const DocumentTrashResultSchema = z.strictObject({ ok: z.literal(true) });
export type DocumentTrashItem = z.infer<typeof DocumentTrashItemSchema>;
export type DocumentTrashSource = z.infer<typeof DocumentTrashSourceSchema>;
